import { useEffect, useRef, useState } from 'react';

const VARIANT_CLASS = {
  up: 'reveal-up',
  down: 'reveal-down',
  left: 'reveal-left',
  right: 'reveal-right',
  zoom: 'reveal-zoom',
};

const STAGGER_SCALE = 1.4;

function Reveal({
  children,
  className = '',
  variant = 'up',
  delay = 0,
  as: Tag = 'div',
  style,
}) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        setVisible(true);
        observer.disconnect();
      },
      { threshold: 0.12, rootMargin: '0px 0px 8% 0px' }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <Tag
      ref={ref}
      className={`reveal ${VARIANT_CLASS[variant] || VARIANT_CLASS.up} ${
        visible ? 'is-visible' : ''
      } ${className}`.trim()}
      style={{ transitionDelay: `${Math.round(delay * STAGGER_SCALE)}ms`, ...style }}
    >
      {children}
    </Tag>
  );
}

export default Reveal;
